import { apiGetFile, GetReportRequest } from 'api';

export const getRespondedOnTimeReportCsv = (request: GetReportRequest): Promise<Blob> =>
  apiGetFile('reports/respondedontime/csv', request);
